// extracted by mini-css-extract-plugin
export default {"wrap":"overlay_wrap__1LrA8"};